import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuToolbarComponent } from './components/menu-toolbar/menu-toolbar.component';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [MenuToolbarComponent],
    exports: [MenuToolbarComponent],
    imports: [CommonModule, RouterModule, MatListModule, MatIconModule],
})
export class MenuToolbarModule {}
